import { render } from "./DriverInfo.vue?vue&type=template&id=10ef2a98&scoped=true"
import script from "./DriverInfo.vue?vue&type=script&lang=js"
export * from "./DriverInfo.vue?vue&type=script&lang=js"

import "./DriverInfo.vue?vue&type=style&index=0&id=10ef2a98&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10ef2a98"]])

export default __exports__